import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import Layout from "@/views/layout";
import BaseRouter from "./views/layout/baseRouter";
// import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/auth-redirect"]; // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    // start progress bar
    NProgress.start();
    const hasToken = getToken();
    if (hasToken) {
        if (to.path === "/login") {
            next({ path: "/index" });
            NProgress.done(); // hack: https://github.com/PanJiaChen/pull/2939
        } else {
            if (store.getters.zsname) {
                next();
            } else {
                try {
                    if (process.env.VUE_APP_ROOT === "local") {
                        const accessRoutes = await store.dispatch(
                            "permission/generateRoutes", []
                        );
                        router.addRoutes(accessRoutes);
                    } else {
                        await store.dispatch("user/getmenu");
                        const menus = [];
                        // console.log(store.getters.menus, 'store.getters.menus')
                        filterAsyncRouter(menus, store.getters.menus, 0); // 1.过滤路由
                        // console.log(menus)
                        router.addRoutes(menus); // 2.动态添加路由
                        global.antRouter = menus; // 3.将路由数据传递给全局变量，做侧边栏菜单渲染工作
                    }

                    await store.dispatch("user/getInfo");
                    next({ ...to, replace: true });
                } catch (error) {
                    await store.dispatch("user/resetToken");
                    Message.error(error || "Has Error");
                    next(`/login?redirect=${to.path}`);
                    NProgress.done();
                }
            }
        }
    } else {
        /* has no token*/

        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`);
            NProgress.done();
        }
    }
});

router.afterEach(() => {
    // finish progress bar
    NProgress.done();
});

function filterAsyncRouter(routes, asyncRouterMap, i) {
    if (asyncRouterMap) {
        asyncRouterMap.forEach(item => {
            const menu = {
                path: item.resourceKey,
                name: item.routeName,
                meta: {
                    title: item.resourceName,
                    icon: item.menuIcon,
                    activeMenu: ''
                },
                hidden: item.resourceType === 2, // menuType 判断路由类型   1.菜单 2.页面
                children: []
            };
            if (i !== 0) {
                if (item.childMenuList.length > 0) {
                    menu.component = BaseRouter;
                } else {
                    // // 后端返回按钮数据处理成可直接使用数据
                    // const oldtablebtn = item.buttonList.filter((item) => item.type === 1)
                    // const operationbtn = item.buttonList.filter((item) => item.type !== 1)
                    // const Obj = oldtablebtn.reduce((pre, cur, index) => {
                    //   if (!pre[cur.label]) { // 判断是否存在当前表头
                    //     // 如果没有
                    //     pre[cur["label"]] = { pram: cur["name"], label: cur["label"], btn: true, btnType: cur["operatorProperties"], auth: cur["auth"], };
                    //   } else {
                    //     if (pre[cur.label]['pram'] instanceof Array) { // 判断是否是多个按钮
                    //       pre[cur.label]['pram'].push({ btnlable: cur["name"], btnType: cur["operatorProperties"], auth: cur["auth"], isIcon: cur["way"] });
                    //     } else {
                    //       pre[cur.label] = { pram: [{ btnlable: pre[cur.label]['pram'], btnType: pre[cur.label]['btnType'], auth: pre[cur.label]["auth"], isIcon: pre[cur.label]['way'] }], label: cur["label"], btn: true, }
                    //       pre[cur.label]['pram'].push({ btnlable: cur["name"], auth: cur["auth"], btnType: cur["operatorProperties"], isIcon: cur["way"] });
                    //     }
                    //   }
                    //   return pre;
                    // }, {});
                    // const newtablebtn = Object.keys(Obj).map((item) => {
                    //   return Obj[item];
                    // });
                    // menu.meta = { ...menu.meta, tablebtn: newtablebtn, operationbtn: operationbtn }
                    menu.component = resolve =>
                        require([`@/views${item.resourceKey}`], resolve); // import('./views' + item.route)
                }
                menu.name = item.routeName;
                menu.meta.activeMenu = item.resourceKey.substr(0, item.resourceKey.lastIndexOf("/"));
            } else {
                if (item.childMenuList.length > 0) {
                    menu.component = Layout;
                    menu.name = item.routeName;
                } else {
                    menu.path = item.resourceKey.substr(0, item.resourceKey.indexOf("/"));
                    menu.component = Layout;
                    menu.name = item.routeName;
                    menu.children = [{
                        path: item.resourceKey.substr(item.resourceKey.indexOf("/") + 1),
                        name: item.routeName,
                        component: resolve => require([`@/views${item.resourceKey}`], resolve),
                        xxxis: "./views",
                        meta: {
                            title: item.resourceName,
                            icon: item.menuIcon,
                            noCache: item.menuType === 1,
                            activeMenu: item.resourceKey.substr(0, item.resourceKey.lastIndexOf("/"))
                        }
                    }];
                }
            }
            if (item.childMenuList.length > 0) {
                filterAsyncRouter(menu.children, item.childMenuList, 1);
            }
            routes.push(menu);
        });
    }
}
